import React from 'react';
import { MERKMAL_LABEL } from '../fragenkatalog';
import { DreiWeg, Zahlfeld } from './GrundlagenBausteine';
import type { GrundlagenProps } from './typen';

/** Abschnitt „Umfang des Vorhabens": Kennzahlen der Schwellenwertpruefung,
 *  Leistungsphase, mehrere Arbeitgeber, Unternehmer ohne Beschaeftigte. */
export const GrundlagenUmfang: React.FC<GrundlagenProps> = ({
    merkmale, lph, isReadOnly, onMerkmal, onZahl, onLph,
}) => (
    <section className="bg-white rounded-2xl border border-slate-200 p-5">
        <h3 className="font-bold text-slate-800 mb-1">Umfang des Vorhabens</h3>
        <p className="text-xs text-slate-500 mb-4">
            Grundlage der Schwellenwertprüfung nach § 2 Abs. 2 BaustellV.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <Zahlfeld
                label="Bauzeit"
                einheit="Arbeitstage"
                wert={merkmale.arbeitstage}
                disabled={isReadOnly}
                onChange={w => onZahl('arbeitstage', w)}
                hinweis="Schwelle: mehr als 30"
            />
            <Zahlfeld
                label="Beschäftigte gleichzeitig"
                einheit="Personen"
                wert={merkmale.maxBeschaeftigte}
                disabled={isReadOnly}
                onChange={w => onZahl('maxBeschaeftigte', w)}
                hinweis="Schwelle: mehr als 20"
            />
            <Zahlfeld
                label="Umfang"
                einheit="Personentage"
                wert={merkmale.personentage}
                disabled={isReadOnly}
                onChange={w => onZahl('personentage', w)}
                hinweis="Schwelle: mehr als 500"
            />
            <div>
                <span className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1">
                    Leistungsphase (HOAI)
                </span>
                <select
                    value={lph === null || lph === undefined ? '' : String(lph)}
                    disabled={isReadOnly}
                    onChange={e => onLph(e.target.value ? Number(e.target.value) : null)}
                    className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm disabled:bg-slate-50"
                >
                    <option value="">— nicht festgelegt —</option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(n => (
                        <option key={n} value={n}>LPH {n}</option>
                    ))}
                </select>
                <span className="block text-[11px] text-slate-400 mt-1">
                    Fragen zu Ausschreibung und Übergabe entstehen erst ab LPH 5 bzw. 6;
                    nicht mehr beeinflussbare Fragen werden markiert
                </span>
            </div>
        </div>

        <div className="mt-4 pt-4 border-t border-slate-100 divide-y divide-slate-100">
            <DreiWeg
                label="Beschäftigte mehrerer Arbeitgeber werden tätig (einschl. Nachunternehmern, Lieferantenmontagen, Eigenleistungen)"
                wert={merkmale.mehrereArbeitgeber}
                disabled={isReadOnly}
                onChange={w => onMerkmal('mehrereArbeitgeber', w)}
            />
            {/* Punkt 9 der Vorankuendigung; die Zahl fragt PL-B-10. */}
            <DreiWeg
                label={MERKMAL_LABEL.unternehmerOhneBeschaeftigte}
                wert={merkmale.unternehmerOhneBeschaeftigte}
                disabled={isReadOnly}
                onChange={w => onMerkmal('unternehmerOhneBeschaeftigte', w)}
            />
        </div>
    </section>
);
